import { useEffect, useState, useRef } from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdNoleggio,convertiIdInventario,materialeDisponibile,analisiMateriale,sovrapposti,ordinaPerData} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import {noleggi_off,utenti_off} from "../offline/offline_costanti.js";
/* global $ */
function NoleggiTabella({datiNoll, numeroConto}){
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
   let modificheNomi = {
  aggiunti: [],
  eliminati: [],
  modificati: [],
};
function handleClick(cellInfo,materiale,utenti) {
    const content=mostraDettagliMateriale(materiale,utenti,cellInfo.data,cellInfo)
    $("#infoMateriale").dxPopup("instance").option( "title",`Dettagli noleggio di ${cellInfo.data.nome}`);
    $("#infoMateriale").dxPopup("instance").option("contentTemplate", () => content);
    $("#infoMateriale").dxPopup("instance").show();
}
function modificaLista(lista,aggiunta,valore,eliminazione,cellInfo) {
    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    if (!eliminazione){
    contenuto.id="textboxmodifica"
    setTimeout(() => {
        $("#textboxmodifica").dxTextBox({label:aggiunta ? "Aggiungi nome": "Modifica nome",value: aggiunta ? null : lista[valore]

        })
    },0)}
    else {
        contenuto.innerText = `Sei sicuro di volere eliminare il nome di ${lista[valore]}?`
        contenuto.style.marginTop = "10px";
        contenuto.style.fontWeight = "bold";
        contenuto.style.fontSize = "20px";
        contenuto.style.fontFamily = "Poppins, sans-serif";
        const contenuto2 =document.createElement("p")
        contenuto2.innerText = `*Verranno eliminati anche tutti i noleggi associati a questo nome. Le modifiche verranno applicate alla conferma di modifica del noleggio.`
        contenuto2.style.marginTop = "10px";
        contenuto2.style.fontWeight = "normal";
        contenuto2.style.fontSize = "15px";
        contenuto2.style.fontFamily = "Poppins, sans-serif";
        contenuto.appendChild(contenuto2)

    }
    $("#modificaListaNomi").dxPopup("instance").option( "title",eliminazione? `Conferma eliminazione di ${lista[valore]}` : aggiunta ? `Aggiungi nome` : `Modifica nome di ${lista[valore]}`);
    $("#modificaListaNomi").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#modificaListaNomi").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'before',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick() { $("#modificaListaNomi").dxPopup("instance").hide();
            if (aggiunta) {
                let datas=($("#val_nomi").dxSelectBox("instance").option("dataSource"))

                datas=[...datas,{id: $("#textboxmodifica").dxTextBox("instance").option("value"),"text":$("#textboxmodifica").dxTextBox("instance").option("value")}]
                $("#val_nomi").dxSelectBox("instance").option("dataSource",datas)
                modificheNomi["aggiunti"]=[...modificheNomi["aggiunti"],$("#textboxmodifica").dxTextBox("instance").option("value")]

            }
            else {
                if (!eliminazione) {
                    let lista=($("#val_nomi").dxSelectBox("instance").option("dataSource"))
                    let elemento = lista.find(obj => obj.id === ($("#val_nomi").dxSelectBox("instance").option("value")));
                    if (elemento) {
                      elemento.id = $("#textboxmodifica").dxTextBox("instance").option("value");
                      elemento.text = $("#textboxmodifica").dxTextBox("instance").option("value");
                      $("#val_nomi").dxSelectBox("instance").option("dataSource",lista)
                      modificheNomi["modificati"]=[...modificheNomi["modificati"],{"vecchio":$("#val_nomi").dxSelectBox("instance").option("value"),"nuovo":$("#textboxmodifica").dxTextBox("instance").option("value")}]
                      $("#val_nomi").dxSelectBox("instance").option("value",$("#textboxmodifica").dxTextBox("instance").option("value"))

                    }
                }
                else {
                    let lista=($("#val_nomi").dxSelectBox("instance").option("dataSource"))
                    lista = lista.filter(obj => obj.id !== $("#val_nomi").dxSelectBox("instance").option("value"));

                    $("#val_nomi").dxSelectBox("instance").option("dataSource",lista)
                    $("#val_nomi").dxSelectBox("instance").option("value",cellInfo.data.nome)
                    modificheNomi["eliminati"]=[...modificheNomi["eliminati"],$("#val_nomi").dxSelectBox("instance").option("value")]
                }
            }
            let dataGrid = $("#gridContainerSecond2").dxDataGrid("instance");
            dataGrid.cellValue(cellInfo.rowIndex, "nomi",    $("#val_nomi").dxSelectBox("instance").option("dataSource").map(name =>name.id));

        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#modificaListaNomi").dxPopup("instance").hide();

        },
      },
    }],)
    $("#modificaListaNomi").dxPopup("instance").show();

}
function mostraDettagliMateriale(materiale,utenti,noleggio,cellInfoNol) {
  const allineamento="center"
  var nomiPresenti=false
  for (const i of materiale) {if (i.rentalname) {nomiPresenti=true}}
  const formattedRows2 = materiale.map((row, index) => ({
    id: index,
    rentinvlinkid:row.rentinvlinkid,
    inventoryid:row.inventoryid,
    inizio: convertDate(row.rentinvlinkfrom).toISO({ includeOffset: false }),
    fine: convertDate(row.rentinvlinkto).toISO({ includeOffset: false }),
    durata: convertDate(row.rentinvlinkto)-convertDate(row.rentinvlinkfrom),
    nome:row.rentalname,
    tipoMateriale:`${convertiIdInventario(row.inventorytype)}`,
    materiale:`${row.inventorybrand} ${row.inventorymeasure} ${row.inventorydescr} ${row.inventoryyear} ${row.inventorynotes ? row.inventorynotes : ""}`,
    assistenza: nome_id({id:row.assistedby, utenti:utenti}),
    nomi:cellInfoNol.data.nomi,
  }));
  const div = document.createElement("div");
  div.style.padding = "0px";
  const analisiContenuto=analisiMateriale(materiale,div,noleggio.nome,noleggio.tipo,noleggio.nomi)

  const inner = document.createElement("div");
  inner.id = "gridContainerSecond2";
  div.appendChild(inner);
  setTimeout(() => {
    $("#gridContainerSecond2").dxDataGrid({
      dataSource: formattedRows2,
      columns: [
        {
          dataField: "inizio",
          caption: "Data e ora inizio",
          hidingPriority:4,
          alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio").length===0) {
                $('<div id="val_inizio"></div>').appendTo(cellElement)
            }
            $("#val_inizio").dxDateBox({type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",value:cellInfo.value, onValueChanged: function(e) {
            const fine=DateTime.fromISO($("#val_fine").dxDateBox("instance").option("value"))
            const inizio=DateTime.fromISO(e.value)
            const durata=(fine-inizio)/60000
            const ore=Math.floor(durata / 60)
            var minuti=durata%60
            if (minuti<10) { minuti=`0${minuti}`}
            else {minuti=minuti.toString()}
            const durataStringa=ore.toString()+minuti
            $("#val_durata_lez").dxTextBox("instance").option("value",durataStringa)
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            $('#val_nomi').dxValidator('validate')

            }})
          }
        },
        { dataField: "fine", alignment:allineamento,caption: "Data e ora fine", hidingPriority:3,customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy HH:mm");
          },
          editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_fine").length===0) {
                $('<div id="val_fine"></div>').appendTo(cellElement)
            }
            $("#val_fine").dxDateBox({type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            const inizio=DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value"))
            const fine=DateTime.fromISO(e.value)
            const durata=(fine-inizio)/60000
            const ore=Math.floor(durata / 60)
            var minuti=durata%60
            if (minuti<10) { minuti=`0${minuti}`}
            else {minuti=minuti.toString()}
           const durataStringa=ore.toString()+minuti
           $("#val_durata_lez").dxTextBox("instance").option("value",durataStringa)
           $('#val_nomi').dxValidator('validate')
            }})
          }
  },
        { dataField: "durata", alignment:allineamento,caption: "Durata noleggio",hidingPriority:5,customizeText: function (e) {

            return differenzaOrario({dataInizio:e.value},);
          },
          editCellTemplate:  function (cellElement,cellInfo) {
          if ($("#val_durata_lez").length===0) {
                $('<div id="val_durata_lez"></div>').appendTo(cellElement)
            }
            const diffMin_or = Math.floor(cellInfo.value / 60000); // millisecondi in minuti
            const ore_ad = Math.floor(diffMin_or / 60);
            const minuti_ad = diffMin_or % 60;
            $("#val_durata_lez").dxTextBox({mask:'0:00',value: minuti_ad<10 ? `${ore_ad}:0${minuti_ad}`:`${ore_ad}:${minuti_ad}` , onValueChanged: async function(e) {
            const durationString = e.value;
            const hours = parseInt(durationString[0])
            const minutes =parseInt(durationString.slice(1, 3))
            const valoreInMs = (hours * 60 + minutes) * 60000;
            cellInfo.setValue(valoreInMs);
            const fine=DateTime.fromMillis(DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value"))+valoreInMs).toISO({includeOffset:false})
            $("#val_fine").dxDateBox("instance").option("value",fine)
            const rowData = cellInfo.row.data;
            const tipo_k=$("#val_tipo_mat").dxSelectBox("instance").option("value")
            const inizio_2=DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value"),{ zone: "Africa/Nairobi" })
            const fine_2=DateTime.fromISO($("#val_fine").dxDateBox("instance").option("value"),{ zone: "Africa/Nairobi" })

            const dati_ut = await materialeDisponibile({dataInizio:inizio_2,dataFine:fine_2,idEsclusi:[rowData.inventoryid]})

            $("#val_materiale").dxSelectBox("instance").option("dataSource",dati_ut[tipo_k])
            $('#val_nomi').dxValidator('validate')
            }})
          }
        },
        { dataField: "assistenza",alignment:allineamento, caption: "Assistito da" ,hidingPriority:2,

        editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_assistente").length===0) {
                $('<div id="val_assistente"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
             let dati_ut=[]
             for (let utente of utenti) {
                dati_ut=[...dati_ut,{ID:utente.userid,nome:`${utente.name} ${utente.surname}`}]
             }
             dati_ut=[...dati_ut,{ID:0,nome:"Nessuno"}]
            $("#val_assistente").dxSelectBox({dataSource:dati_ut , displayExpr:"nome",valueExpr:"ID",value:nome_id({nome:cellInfo.value,utenti:utenti}),onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        { dataField: "tipoMateriale",alignment:allineamento,caption: "Tipo Materiale" ,hidingPriority:1,

        editCellTemplate: function  (cellElement,cellInfo) {
          if ($("#val_tipo_mat").length===0) {
                $('<div id="val_tipo_mat"></div>').appendTo(cellElement)
            }
             const rowData = cellInfo.row.data;
             let dati_ut=[]
             for (let i = 1; i <= 5; i++) {
              dati_ut=[...dati_ut,{ID:i,nome:convertiIdInventario(i)}]
            }
            $("#val_tipo_mat").dxSelectBox({dataSource:dati_ut , displayExpr:"nome",valueExpr:"ID",value:convertiIdInventario(cellInfo.value),onValueChanged: async function(e) {
            cellInfo.setValue(e.value)
            const rowData = cellInfo.row.data;
            const tipo_k=e.value
            const inizio_2=DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value"),{ zone: "Africa/Nairobi" })
            const fine_2=DateTime.fromISO($("#val_fine").dxDateBox("instance").option("value"),{ zone: "Africa/Nairobi" })
            const dati_ut = await materialeDisponibile({dataInizio:inizio_2,dataFine:fine_2,idEsclusi:[rowData.inventoryid]})
            $("#val_materiale").dxSelectBox("instance").option("dataSource",dati_ut[tipo_k])
            if (e.value===rowData.tipoMateriale){
                $("#val_materiale").dxSelectBox("instance").option("value",rowData.inventoryid)}
            },
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
        },
        {dataField:"materiale",alignment:allineamento,caption:"Materiale noleggiato",hidingPriority:7,
        editCellTemplate: async function  (cellElement,cellInfo) {
          if ($("#val_materiale").length===0) {
                $('<div id="val_materiale"></div>').appendTo(cellElement)
            }
           const rowData = cellInfo.row.data;
           const tipo_k=$("#val_tipo_mat").dxSelectBox("instance").option("value")
           const inizio=DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value"),{ zone: "Africa/Nairobi" })
           const fine=DateTime.fromISO($("#val_fine").dxDateBox("instance").option("value"),{ zone: "Africa/Nairobi" })
           const dati_ut = await materialeDisponibile({dataInizio:inizio,dataFine:fine,idEsclusi:[rowData.inventoryid]})
            $("#val_materiale").dxSelectBox({dataSource:dati_ut[[tipo_k]] ,searchEnabled:true, displayExpr:"nome",valueExpr:"ID",value:rowData.inventoryid? parseInt(rowData.inventoryid):null,onValueChanged: function(e) {

            cellInfo.setValue(e.value)},
            onInitialized: function () {
    setTimeout(() => {

      const validator = $("#val_materiale").dxValidator("instance");
      if (validator) {
        validator.validate();
      }
    }, 0);
  },
            elementAttr: {
                class: "istruttore-style"
              },
            }).dxValidator({validationRules: [
      { type: "required", message: "Il campo Materiale è obbligatorio.",}
    ],});
          },
        },
        {dataField:"nome",visible:nomiPresenti,alignment:allineamento,hidingPriority:6,caption:"Noleggiato da",
        editCellTemplate: function (cellElement,cellInfo){
            if ($("#val_nomi").length===0) {
                $('<div id="val_nomi"></div>').appendTo(cellElement)
            }

            const namesList = cellInfo.data.nomi ?cellInfo.data.nomi: cellInfoNol.data.nomi
            let selectBoxData=[]
            if (namesList)
             selectBoxData = namesList.map(name => ({ id: name, text: name }));

            $("#val_nomi").dxSelectBox({
                dataSource: selectBoxData,
                valueExpr: 'id', // Utilizza "id" per identificare un elemento
                displayExpr: 'text', // Mostra il "text" dell'elemento nella lista
                showClearButton: true,
                value:cellInfo.value,
                searchEnabled:true,
                onValueChanged: function(e) {
                cellInfo.setValue(e.value)},
                buttons: [{
                  name: 'modifica',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {
                        return $("<i class='fa-solid fa-pencil'></i>");
                    },
                    onClick(e) {
                      if ($("#val_nomi").dxSelectBox("instance").option("value")){
                      var indice=0
                      var contatore=0
                      for (let i of namesList){
                        if (i===$("#val_nomi").dxSelectBox("instance").option("value")) {indice = contatore}
                        contatore+=1
                      }
                      modificaLista(namesList,false,indice,false,cellInfo)} else {
                      const message = `Seleziona un nome per poter modificare!`;
                        window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRentals',

                        },}, "error", 1000);
                      }
                    },
                  },
                },
                {
                  name: 'aggiungi',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {
                        return $("<i class='fa-solid fa-plus'></i>");
                    },
                    onClick(e) {
                      modificaLista(selectBoxData,true,0,false,cellInfo)
                    },
                  },
                },
                {
                  name: 'elimina',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {

                        return $("<i class='fa-solid fa-trash-can'></i>");
                    },
                    onClick(e) {
                      if ($("#val_nomi").dxSelectBox("instance").option("value")){
                        var indice=0
                      var contatore=0
                      for (let i of namesList){
                        if (i===$("#val_nomi").dxSelectBox("instance").option("value")) {indice = contatore}
                        contatore+=1
                      }
                      modificaLista(namesList,false,indice,true,cellInfo)
                      } else
                      {
                        const message = `Seleziona un nome per poter eliminare!`;
                        window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRentals',

                        },}, "error", 1000);
                      }
                    },
                  },
                },
                ]
            }).dxValidator({validationRules: [
      { type: "custom", message: "Il campo Nome è obbligatorio se ci sono altri noleggi alla stessa ora",
       validationCallback : function() {
           const altriNol=noleggio.inventories
           const inizio=DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value")).toMillis()
           const fine=DateTime.fromISO($("#val_fine").dxDateBox("instance").option("value")).toMillis()
           var siSovrappone=true
           const tipo=$("#val_tipo_mat").dxSelectBox("instance").option("value")
           if (!($("#val_nomi").dxSelectBox("instance").option("value"))){
           for (let i of altriNol){ if (sovrapposti(convertDate(i.rentinvlinkfrom),convertDate(i.rentinvlinkto),inizio,fine) && ( (tipo===1 && noleggio.tipo===1) || (noleggio.tipo!==1) ) ){siSovrappone=false}}}
           return siSovrappone
       }
       }
    ],});
            },
        },
        {dataField:"nomi",visible:false},
        {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica noleggio`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "inizio","fine","durata","assistenza","tipoMateriale","materiale","nome"
                ],
              },
            ],
          },
      },
       onSaving: function(e) {
       var isValid=true
        if ($("#val_nomi").dxValidator("instance")){
         isValid = $("#val_nomi").dxValidator("instance").validate().isValid;}
         if ($("#val_materiale").dxValidator("instance")){
         isValid = $("#val_materiale").dxValidator("instance").validate().isValid;}
        // Se la validazione fallisce, impedisci il salvataggio
        if (!isValid) {
            e.cancel = true; // Impedisce il salvataggio dei dati
            const message = `Ci sono errori di validazione.`;
            window.DevExpress.ui.notify({ message, position: { my: 'center', at: 'center', of: '#gridContainerRentals',  } }, "error", 1000);
        }
    },
      onRowInserting: async function (e) {
            const gridElement = $("#gridContainerSecond2"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            const dati_n={'rentalnames':JSON.stringify(e.data.nomi)};
            var richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:cellInfoNol.data.rentalid,
                valori:dati_n,
                azione:'setRental'})
            $("#loadingOverlay").show()
            for (let i of modificheNomi["modificati"]) {
                for (let noleggio of cellInfoNol.data.inventories) {
                    if (noleggio.rentalname===i.vecchio) {
                        const dati_medio={"rentalname":i.nuovo}
                        richiesta = await funzione_collegamento({
                           userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            setId:noleggio.rentinvlinkid,
                            valori:dati_medio,
                            azione:'setLinkRentInv'})
                    }
                }
            }
            for (let i of modificheNomi["eliminati"]) {
                for (let noleggio of cellInfoNol.data.inventories) {
                    if (noleggio.rentalname===i) {
                        richiesta = await funzione_collegamento({
                           userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            delId:noleggio.rentinvlinkid,
                            azione:'delLinkRentInv'})
                    }
                }
            }
            modificheNomi = {
              aggiunti: [],
              eliminati: [],
              modificati: [],
            };
            const jsDate = new Date(e.data.inizio);
            const baseDate2 = DateTime.fromJSDate(jsDate)
            const basedate2iso=baseDate2.toISO({ includeOffset: false })
            const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
            const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
            const istruttore=nome_id({nome:e.data.assistenza,utenti:utenti})
            const dati2={"rentalid":cellInfoNol.data.rentalid,"inventoryid": $("#val_materiale").dxSelectBox("instance").option("value"),"rentinvlinkfrom":convertDate(DateTime.fromISO(baseDate),false,true),"rentinvlinkto":convertDate(updatedDate,false,true),"assistedby":istruttore,"rentalname":e.data.nome,}
             richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.rentinvlinkid,
                valori:dati2,
                azione:'setLinkRentInv'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `Noleggio di ${e.data.nome} modificato con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerRentals',

                },}, "success", 1000);
          const dati = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getRentals",
            filtri:{"billid":numeroConto},
            childs: ["inventories"],
            })
          const formattedRows=dati.map((row, index) => ({
          id:index,
          rentalid:row.rentalid,
          data:convertDate(row.rentalregdate).toISO({ includeOffset: false }),
          nome:row.rentalcustname,
          tipo:row.rentaltype,
          costo:row.rentalcost,
          pagato:row.rentaladvance,
          metodo:row.rentalpaymentmethod,
          periodo:[row.rentalfrom,row.rentalto],
          nonDisp:row.rentalcustunavailable,
          durata:(row.rentalto&&row.rentalfrom)?Math.floor((convertDate(row.rentalto)-convertDate(row.rentalfrom))/(60*60000*24)):null,
          sconto:row.rentaldiscount,
          costo_scontato: (row.rentalcost * (1 - (row.rentaldiscount || 0) / 100)),
          inventories:ordinaPerData(row.inventories,"rentinvlinkfrom"),
          nomi:row.rentalnames,
          }))
          $("#gridContainerRentals").dxDataGrid("instance").option("dataSource",formattedRows)
          nomiPresenti=false
          const noleggioN=formattedRows[noleggio.id]
          materiale=noleggioN.inventories
          for (const i of materiale) {if (i.rentalname) {nomiPresenti=true}}
          const formattedRows2 = materiale.map((row, index) => ({
            id: index,
            rentinvlinkid:row.rentinvlinkid,
            inventoryid:row.inventoryid,
            inizio: convertDate(row.rentinvlinkfrom).toISO({ includeOffset: false }),
            fine: convertDate(row.rentinvlinkto).toISO({ includeOffset: false }),
            durata: convertDate(row.rentinvlinkto)-convertDate(row.rentinvlinkfrom),
            nome:row.rentalname,
            tipoMateriale:`${convertiIdInventario(row.inventorytype)}`,
            materiale:`${row.inventorybrand} ${row.inventorymeasure} ${row.inventorydescr} ${row.inventoryyear} ${row.inventorynotes ? row.inventorynotes : ""}`,
            assistenza: nome_id({id:row.assistedby, utenti:utenti}),
            nomi:cellInfoNol.data.nomi,
          }));
          $("#gridContainerSecond2").dxDataGrid("instance").option("dataSource",formattedRows2)

          analisiMateriale(materiale,$("#infoMateriale").dxPopup("instance").$content(),noleggioN.nome,noleggioN.tipo,noleggioN.nomi)
          }
          },
      onInitNewRow: function (e) {
        e.data.inizio=DateTime.now().toISO();
        e.data.fine=DateTime.now().plus({ hours: 1 }).toISO();
        e.data.durata=60*60000;
        e.data.tipoMateriale="Kite";
        e.data.materiale = null;


        },
      onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.rentinvlinkid,
                azione:'delLinkRentInv',
                return_data:false})
            if (richiesta) {
                const message = `Noleggio di ${e.data.nome} eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerSecond2',

                },}, "success", 1000);
                const dati = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getRentals",
            filtri:{"billid":numeroConto},
            childs: ["inventories"],
            })
                const formattedRows=dati.map((row, index) => ({
          id:index,
          rentalid:row.rentalid,
          data:convertDate(row.rentalregdate).toISO({ includeOffset: false }),
          nome:row.rentalcustname,
          tipo:row.rentaltype,
          costo:row.rentalcost,
          pagato:row.rentaladvance,
          metodo:row.rentalpaymentmethod,
          periodo:[row.rentalfrom,row.rentalto],
          nonDisp:row.rentalcustunavailable,
          durata:(row.rentalto&&row.rentalfrom)?Math.floor((convertDate(row.rentalto)-convertDate(row.rentalfrom))/(60*60000*24)):null,
          sconto:row.rentaldiscount,
          costo_scontato: (row.rentalcost * (1 - (row.rentaldiscount || 0) / 100)),
          inventories:ordinaPerData(row.inventories,"rentinvlinkfrom"),
          nomi:row.rentalnames,
          }))
          $("#gridContainerRentals").dxDataGrid("instance").option("dataSource",formattedRows)
          const noleggioN=formattedRows[noleggio.id]
          analisiMateriale(noleggioN.inventories,$("#infoMateriale").dxPopup("instance").$content(),noleggioN.nome,noleggioN.tipo,noleggioN.nomi)}
        },
      onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerSecond2"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            const dati_n={'rentalnames':JSON.stringify(e.data.nomi)};
            var richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:cellInfoNol.data.rentalid,
                valori:dati_n,
                azione:'setRental'})
            $("#loadingOverlay").show()
            for (let i of modificheNomi["modificati"]) {
                for (let noleggio of cellInfoNol.data.inventories) {
                    if (noleggio.rentalname===i.vecchio) {
                        const dati_medio={"rentalname":i.nuovo}
                        richiesta = await funzione_collegamento({
                           userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            setId:noleggio.rentinvlinkid,
                            valori:dati_medio,
                            azione:'setLinkRentInv'})
                    }
                }
            }
            for (let i of modificheNomi["eliminati"]) {
                for (let noleggio of cellInfoNol.data.inventories) {
                    if (noleggio.rentalname===i) {
                        richiesta = await funzione_collegamento({
                           userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            delId:noleggio.rentinvlinkid,
                            azione:'delLinkRentInv'})
                    }
                }
            }
            modificheNomi = {
              aggiunti: [],
              eliminati: [],
              modificati: [],
            };
            const jsDate = new Date(e.data.inizio);
            const baseDate2 = DateTime.fromJSDate(jsDate)
            const basedate2iso=baseDate2.toISO({ includeOffset: false })
            const baseDate=DateTime.fromISO(basedate2iso,{ zone: "Africa/Nairobi" })
            const updatedDate = baseDate.plus({ milliseconds:e.data.durata });
            const istruttore=e.data.assistenza
            const dati2={"rentalid":cellInfoNol.data.rentalid,"inventoryid": $("#val_materiale").dxSelectBox("instance").option("value"),"rentinvlinkfrom":convertDate(DateTime.fromISO(baseDate),false,true),"rentinvlinkto":convertDate(updatedDate,false,true),"assistedby":istruttore,"rentalname":e.data.nome,}
            richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.rentinvlinkid,
                valori:dati2,
                azione:'setLinkRentInv'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `Noleggio di ${e.data.nome} modificato con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerRentals',

                },}, "success", 1000);
          const dati = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getRentals",
            filtri:{"billid":numeroConto},
            childs: ["inventories"],
            })
          const formattedRows=dati.map((row, index) => ({
          id:index,
          rentalid:row.rentalid,
          data:convertDate(row.rentalregdate).toISO({ includeOffset: false }),
          nome:row.rentalcustname,
          tipo:row.rentaltype,
          costo:row.rentalcost,
          pagato:row.rentaladvance,
          metodo:row.rentalpaymentmethod,
          periodo:[row.rentalfrom,row.rentalto],
          nonDisp:row.rentalcustunavailable,
          durata:(row.rentalto&&row.rentalfrom)?Math.floor((convertDate(row.rentalto)-convertDate(row.rentalfrom))/(60*60000*24)):null,
          sconto:row.rentaldiscount,
          costo_scontato: (row.rentalcost * (1 - (row.rentaldiscount || 0) / 100)),
          inventories:ordinaPerData(row.inventories,"rentinvlinkfrom"),
          nomi:row.rentalnames,
          }))
          $("#gridContainerRentals").dxDataGrid("instance").option("dataSource",formattedRows)
          nomiPresenti=false
          const noleggioN=formattedRows[noleggio.id]
          analisiMateriale(noleggioN.inventories,$("#infoMateriale").dxPopup("instance").$content(),noleggioN.nome,noleggioN.tipo,noleggioN.nomi)
          materiale=noleggioN.inventories
          for (const i of materiale) {if (i.rentalname) {nomiPresenti=true}}
          const formattedRows2 = materiale.map((row, index) => ({
            id: index,
            rentinvlinkid:row.rentinvlinkid,
            inventoryid:row.inventoryid,
            inizio: convertDate(row.rentinvlinkfrom).toISO({ includeOffset: false }),
            fine: convertDate(row.rentinvlinkto).toISO({ includeOffset: false }),
            durata: convertDate(row.rentinvlinkto)-convertDate(row.rentinvlinkfrom),
            nome:row.rentalname,
            tipoMateriale:`${convertiIdInventario(row.inventorytype)}`,
            materiale:`${row.inventorybrand} ${row.inventorymeasure} ${row.inventorydescr} ${row.inventoryyear} ${row.inventorynotes ? row.inventorynotes : ""}`,
            assistenza: nome_id({id:row.assistedby, utenti:utenti}),
            nomi:cellInfoNol.data.nomi,
          }));
          $("#gridContainerSecond2").dxDataGrid("instance").option("dataSource",formattedRows2)
                }
          },

    });

  }, 0);

  return div;
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStorico() {
    const idNoleggi=[{ID:1,name:"Attrezzatura completa"},{ID:2,name:"Kite e barra"},{ID:3,name:"Tavola twin tip"},{ID: 4,name:"Tavola surfino"},{ID: 5,name:"Tavola foil"},{ID: 6,name:"Harness"},{ID: 7,name:"Lycra e muta"},{ID: 8,name:"Caschetto e giubbotto"},{ID: 9,name:"Twin tip - Surfino"}]
    const allineamento="center"
    let eliminaNome = null;
    let aggiungiNome=null
    useEffect(() => {
        const fetchNoleggi = async () => {
           $("#gridContainerRentals").addClass("grid-container-hidden")
           $("#loadingOverlay").show()
          //const dati= await noleggi_off()
          const utenti = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getUsers",
            })
          const formattedRows=datiNoll.map((row, index) => ({
          id:index,
          rentalid:row.rentalid,
          data:row.rentalregdate?convertDate(row.rentalregdate).toISO({ includeOffset: false }):null,
          nome:row.rentalcustname,
          tipo:row.rentaltype,
          costo:row.rentalcost,
          pagato:row.rentaladvance,
          metodo:row.rentalpaymentmethod,
          periodo:[row.rentalfrom,row.rentalto],
          nonDisp:row.rentalcustunavailable,
          durata:(row.rentalto&&row.rentalfrom)?Math.floor((convertDate(row.rentalto)-convertDate(row.rentalfrom))/(60*60000*24)):null,
          sconto:row.rentaldiscount,
          costo_scontato: (row.rentalcost * (1 - (row.rentaldiscount || 0) / 100)),
          inventories:ordinaPerData(row.inventories,"rentinvlinkfrom"),
          nomi:row.rentalnames,
          }))
          $("#gridContainerRentals").dxDataGrid({
          dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 3,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },

          { dataField: "nome", caption: "Nome", hidingPriority: 7,alignment:allineamento, },
          {
            dataField: "nonDisp",
            caption: "Date non disponibili",
            visible: false, // colonna nascosta
            editCellTemplate: function(cellElement, cellInfo) {
            if ($("#tagBoxContainer").length===0) {
                $('<div id="tagBoxContainer"></div>').appendTo(cellElement)
            }
            let dateG=cellInfo.value
            let dateCont=[]
            let stringaDate=[]

            if (dateG){
                stringaDate=dateG.split(",");
            }
            for (let data of stringaDate){
                if (data)
               dateCont.push(DateTime.fromFormat(data,"yyyyMMdd").toFormat("dd/MM/yyyy"))
            }
                $("#tagBoxContainer").dxTagBox({
    items: [],
        value:   dateCont,
        placeholder: "Date non disponibili",
        showSelectionControls: true,
        acceptCustomValue: true,
        noDataText: "",
        showSelectionControls: false,
        dropDownOptions: {
    contentTemplate: function(e) {
         const selectedDates = ( $("#tagBoxContainer").dxTagBox("instance").option("value")).map(d => {
            const parts = d.split("/"); // dd/MM/yyyy
            return new Date(parts[2], parts[1]-1, parts[0]);
        });
        const $calendarDiv = $('<div id="myCalendar"></div>').css({
    width: "auto",
});
        $calendarDiv.dxCalendar({
            selectionMode: "multiple",
            value: selectedDates,
            onValueChanged: function(calenEvent) {
                if (!calenEvent.value) return;
                const dataS = calenEvent.value.map(date => {
                    return DateTime.fromJSDate(date).toFormat("dd/MM/yyyy")
                });
                $("#tagBoxContainer").dxTagBox("instance").option("value", dataS);
            }
        });

        return $calendarDiv;
    }
},
        onValueChanged: function(e) {
        if ($("#myCalendar").dxCalendar("instance")){
            const selectedDates = ( $("#tagBoxContainer").dxTagBox("instance").option("value")).map(d => {
            const parts = d.split("/"); // dd/MM/yyyy
            return new Date(parts[2], parts[1]-1, parts[0]);})
        if ($("#myCalendar").dxCalendar("instance").option("value").length!==selectedDates.length)
        $("#myCalendar").dxCalendar("instance").option("value",selectedDates)
        let listaM=""
        for (let data of $("#tagBoxContainer").dxTagBox("instance").option("value")){
            listaM+=DateTime.fromFormat(data,"dd/MM/yyyy").toFormat("yyyyMMdd")+","
        }
        cellInfo.setValue(listaM)
        }


    }
});
            }
        },
          { dataField: "tipo", caption: "Tipo", alignment:allineamento,hidingPriority: 4,
          customizeText: function (cellInfo) {
          return convertiIdNoleggio(cellInfo.value)
          },
          editCellTemplate: function(cellElement,cellInfo) {

          if ($("#val_tipo").length===0) {
                $('<div id="val_tipo"></div>').appendTo(cellElement)
            }
          const dataTipo=idNoleggi
          $("#val_tipo").dxSelectBox({dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'name',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const tipo_lez=$("#val_tipo").dxSelectBox("instance").option("value")
            },
            })
          }},
          { dataField: "durata", visible: false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_durata").length===0) {
                $('<div id="val_durata"></div>').appendTo(cellElement)
            }
            $("#val_durata").dxNumberBox({min:0,value:cellInfo.value,format:"#' giorni'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const durationString = e.value;
            const valoreInMs = durationString*60*60000*24
            const fine=DateTime.fromMillis(DateTime.fromJSDate($("#val_periodo").dxDateRangeBox("instance").option("startDate")).setZone('utc', { keepLocalTime: true })+valoreInMs).toJSDate({includeOffset:false})
            $("#val_periodo").dxDateRangeBox("instance").option("endDate",fine)
            const listinoPrezzi = {
  1: { // Attrezzatura completa
    nome: "Attrezzatura completa",
    prezzi: { 1: 70,2:140 ,3: 210, 4:270,5: 330,6:360, 7: 385 }
  },
  2: { // Kite e barra
    nome: "Kite e barra",
    prezzi: { 1: 50, 3: 105, 5: 165, 7: 190 }
  },
  3: { // Tavola twin tip
    nome: "Tavola twin tip",
    prezzi: { 1: 40, 3: 105, 5: 165, 7: 190 }
  },
  4: { // Tavola surfino
    nome: "Tavola surfino",
    prezzi: { 1: 45, 3: 130, 5: 200, 7: 230 }
  },
  5: { // Tavola foil
    nome: "Tavola foil",
    prezzi: { 1: 45, 3: 130, 5: 200, 7: 230 }
  },
  6: { // Harness
    nome: "Harness",
    prezzi: { 1: 10 }
  },
  7: { // Lycra e muta
    nome: "Lycra e muta",
    prezzi: { 1: 10 }
  },
  8: { // Caschetto e giubbotto
    nome: "Caschetto e giubbotto",
    prezzi: { 1: 10 }
  },
  9: { // Twin tip - Surfino
    nome: "Twin tip - Surfino",
    prezzi: {}
  },
  10: { // Material Insurance
    nome: "Material Insurance",
    prezzi: { 1: 10, 7: 50 }
  }
};
if (listinoPrezzi[$("#val_tipo").dxSelectBox("instance").option("value")] && listinoPrezzi[$("#val_tipo").dxSelectBox("instance").option("value")]["prezzi"][$("#val_durata").dxNumberBox("instance").option("value")])
$("#val_costo").dxNumberBox("instance").option("value",listinoPrezzi[$("#val_tipo").dxSelectBox("instance").option("value")]["prezzi"][$("#val_durata").dxNumberBox("instance").option("value")])

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} giorni`;
            }
          },
          {
           dataField: "periodo",
            caption: "Periodo",
            alignment:allineamento,
            hidingPriority: 2,
            calculateDisplayValue: function(rowData) {
                let stringa=""
                if (rowData["periodo"]){
               if (rowData["periodo"][0] && rowData["periodo"][0]){
                    stringa=`dal ${DateTime.fromFormat(rowData["periodo"][0],"yyyyMMdd").toFormat("dd/MM/yyyy")} al ${DateTime.fromFormat(rowData["periodo"][1],"yyyyMMdd").toFormat("dd/MM/yyyy")}`

               }}
               return stringa
            },
            editCellTemplate: function(cellElement,cellInfo){
                if ($("#val_periodo").length===0) {
                    $('<div id="val_periodo"></div>').appendTo(cellElement)
                }
                const start = cellInfo["data"]["periodo"][0] ? DateTime.fromFormat(cellInfo["data"]["periodo"][0], "yyyyMMdd").toJSDate() : null;
                const end = cellInfo["data"]["periodo"][1] ? DateTime.fromFormat(cellInfo["data"]["periodo"][1], "yyyyMMdd").toJSDate() : null;
                $("#val_periodo").dxDateRangeBox({
                startDate: start,
                endDate: end,
                displayFormat: "dd/MM/yyyy",
                startDateLabel: "Arrivo",
                endDateLabel: "Partenza",
                showClearButton: true,
                openOnFieldClick: true,
                onValueChanged: function(e) {
                    if (!e.value) return;
                    const [newStart, newEnd] = e.value;
                    cellInfo.setValue([(newStart)?!(isNaN(newStart.getTime()))?DateTime.fromJSDate(newStart).toFormat("yyyyMMdd"):null:null,(newEnd)?!(isNaN(newEnd.getTime()))?DateTime.fromJSDate(newEnd).toFormat("yyyyMMdd"):null:null])
                    const giorniTot= (newEnd&&newStart)?DateTime.fromJSDate(newEnd, { zone: 'local' }).startOf('day').diff(DateTime.fromJSDate(newStart, { zone: 'local' }).startOf('day'), 'days').days:null

                    console.log(giorniTot,)
                    if (giorniTot)
                    $("#val_durata").dxNumberBox("instance").option("value",giorniTot)
                }
            });
            }
           },

          {
            dataField: "costo",
            caption: "Costo",
            alignment:allineamento,
            hidingPriority: 6,
            calculateDisplayValue: function(rowData) {
    return rowData.costo_scontato ?? rowData.costo;
  },
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo").length===0) {
                $('<div id="val_costo"></div>').appendTo(cellElement)
            }
            $("#val_costo").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const sconto_att=$("#val_sconto").dxNumberBox("instance").option("value")
            $("#val_costo_scontato").dxNumberBox("instance").option("value",cellInfo.value*(1-sconto_att/100))

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          {
            dataField: "pagato",
            caption: "Anticipo",
            hidingPriority: 5,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_anticipo").length===0) {
                $('<div id="val_anticipo"></div>').appendTo(cellElement)
            }
            $("#val_anticipo").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          { dataField: "metodo", caption: "Pagamento", hidingPriority: 1,alignment:allineamento, },
          {dataField: "sconto",visible:false,editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sconto").length===0) {
                $('<div id="val_sconto"></div>').appendTo(cellElement)
            }
            $("#val_sconto").dxNumberBox({showSpinButtons: true,step:5,min:0,value:cellInfo.value,max:100,format:"#0.##'%'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const valore_nuovo=($("#val_costo").dxNumberBox("instance").option("value"))*(1-cellInfo.value/100)
            $("#val_costo_scontato").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }},
          {dataField: "costo_scontato",visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo_scontato").length===0) {
                $('<div id="val_costo_scontato"></div>').appendTo(cellElement)
            }

            const displV=($("#val_costo").dxNumberBox("instance").option("value"))*(1-($("#val_sconto").dxNumberBox("instance").option("value"))/100)
            $("#val_costo_scontato").dxNumberBox({showSpinButtons: true,step:10,min:0,value:displV,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_costo_scontato").dxNumberBox("instance").option("max",$("#val_costo").dxNumberBox("instance").option("value"))
            const valore_nuovo=(1-(e.value)/($("#val_costo").dxNumberBox("instance").option("value")))*100
            $("#val_sconto").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }
          },
          {dataField:"nomi",visible:false,
          },
          {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Dettagli materiale",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() => handleClick(cellInfo,cellInfo.data.inventories,utenti)}
                    />
                  );
                },
              }
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica noleggio",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form:{
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                  "data",
                  "nome",
                  "periodo","durata",]},
                  {
                itemType: "group",
                colCount: 1,
                colSpan: 2,
                items: [
                  "nonDisp",]},
                  {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [

                  {
                    dataField: "tipo",
                    label: { text: "Tipo Noleggio" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "costo",
                    label: { text: "Costo (€)" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "pagato",
                    label: { text: "Pagato (€)" }  // ← Etichetta personalizzata
                  },
                  {
                    dataField: "metodo",
                    label: { text: "Metodo di pagamento" }  // ← Etichetta personalizzata
                  },
                   {
          dataField: "sconto",
          label: {
            text: "Sconto (%)",
          }
        },
        {
          dataField: "costo_scontato",
          label: {
            text: "Costo scontato",
          }
        },]}
                ],
              },
            ],
          },
        },
        onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        e.data.sconto=0;
        e.data.data=DateTime.now().toISODate();
        e.data.periodo=[null,null]
        },
        onRowInserting: async function (e) {
            const gridElement = $("#gridContainerRentals"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
                let data_reg=DateTime.fromFormat(e.data.data,'yyyy-MM-dd')
                data_reg=data_reg.toFormat("yyyyMMdd")
            const dati_n={"rentalregdate":data_reg,'rentaldiscount':e.data.sconto,'rentalcustname':e.data.nome,'rentaltype':e.data.tipo,'rentalcost':e.data.costo,'rentaltype':e.data.tipo,'rentaladvance':e.data.pagato,'rentalpaymentmethod':e.data.metodo,};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setRental'})
                if (richiesta) {
                    const message = `Noleggio di ${e.data.nome} aggiunto con successo`;
                    window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRentals',

                        },}, "success", 1000);
                    const dati = await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: "getRentals",
                        filtri:{"billid":numeroConto},
                        childs: ["inventories"],
                    })
                    const formattedRows=dati.map((row, index) => ({
                      id:index,
                      rentalid:row.rentalid,
                      data:row.rentalregdate?convertDate(row.rentalregdate).toISO({ includeOffset: false }):null,
                      nome:row.rentalcustname,
                      tipo:row.rentaltype,
                      costo:row.rentalcost,
                      pagato:row.rentaladvance,
                      metodo:row.rentalpaymentmethod,
                      periodo:[row.rentalfrom,row.rentalto],
                      nonDisp:row.rentalcustunavailable,
                      durata:(row.rentalto&&row.rentalfrom)?Math.floor((convertDate(row.rentalto)-convertDate(row.rentalfrom))/(60*60000*24)):null,
                      sconto:row.rentaldiscount,
                      costo_scontato: (row.rentalcost * (1 - (row.rentaldiscount || 0) / 100)),
                      inventories:ordinaPerData(row.inventories,"rentinvlinkfrom"),
                      nomi:row.rentalnames,
                      }))
                      $("#gridContainerRentals").dxDataGrid("instance").option("dataSource",formattedRows)
                }

        },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.rentalid,
                azione:'delRental',
                return_data:false})
            if (richiesta) {
                const message = `Noleggio di ${e.data.nome} eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerRentals',

                },}, "success", 1000);}
        },

        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerRentals"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            const dati_n={"rentalfrom":e["data"]["periodo"][0],"rentalto":e["data"]["periodo"][1],"rentalcustunavailable":e.data.nonDisp,'rentalregdate':convertDate(DateTime.fromISO(e.data.data)),'rentaldiscount':e.data.sconto,'rentalcustname':e.data.nome,'rentaltype':e.data.tipo,'rentalcost':e.data.costo,'rentaladvance':e.data.pagato,'rentalpaymentmethod':e.data.metodo,};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.rentalid,
                valori:dati_n,
                azione:'setRental'})
                if (richiesta) {
                const message = `Noleggio di ${e.data.nome} modificato con successo`;

                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerRentals',

                        },}, "success", 1000);
                }
            },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerRentals").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo_scontato);

            if (!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && e.dataField === "data") {

            e.editorName = "dxDateBox";  // Forza DateBox come filtro
            e.editorOptions = {
              displayFormat: "dd/MM/yyyy",
              type: "date",
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
            const dataTipo=idNoleggi
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'name',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
        },

     })};



    fetchNoleggi();
    $("#infoMateriale").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    resizeEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollMateriale" style="height: 100%;"></div>');
    $("#customScrollMateriale").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    }});
    $("#modificaListaNomi").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,

    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollLista" style="height: 100%;"></div>');
    $("#customScrollLista").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });

  }, []);
return (<div id="gridContainerRentals" ></div>)

}
return (<div>
        <TabellaStorico/>
        <div id="infoMateriale"></div>
        <div id="modificaListaNomi"></div>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}
export default NoleggiTabella